import React from 'react';
import * as CSS from 'csstype';
import styled from 'styled-components';
import { Box, Text } from '@99designs/emu';
import { colors, spaces } from '@99designs/emu/settings';
import { IconTag1 } from '@99designs/icons';

type PillProps = {
    color?: CSS.Property.Color | colors.Color;
    textColor?: CSS.Property.Color | colors.Color;
};

const StyledPill = styled(Box)`
    display: inline-block;
    border-radius: 20px;
    padding: 2px 10px;
    background-color: ${({ color }) => color};
`;

const StyledIconTag = styled(IconTag1)`
    font-size: 12px;
    margin-right: ${spaces['0.25bu']};
    margin-bottom: ${spaces['0.25bu']};
`;

export function FlashSalePill({ color, textColor, children }: React.PropsWithChildren<PillProps>) {
    const pillColor = color || colors.risingSun;
    const pillTextColor = textColor || colors.white;
    return (
        <StyledPill color={pillColor}>
            <StyledIconTag color={pillTextColor} />
            <Text size="size2" color={pillTextColor}>
                {children}
            </Text>
        </StyledPill>
    );
}
